// extracted by mini-css-extract-plugin
module.exports = {"skeleton__line":"Placeholder_skeleton__line__3hMZX"};